export const GET_LOGIN_DATA_SUCCESSFULL = "GET_LOGIN_DATA_SUCCESSFULL";
export const GET_PERMISSION_DATA_SUCCESSFULL = "GET_PERMISSION_DATA_SUCCESSFULL";
export const IS_DASHBOARD_LOADED = "IS_DASHBOARD_LOADED";

export const getLoginDataSuccessfull = (payload) =>{
    return{
      type:  GET_LOGIN_DATA_SUCCESSFULL,
      payload
    }
}

export const getPermissionDataSuccessfull = (payload) =>{
  return{
    type:  GET_PERMISSION_DATA_SUCCESSFULL,
    payload
  }
}

export const isDashboardLoaded = (payload) =>{
  return{
    type:  IS_DASHBOARD_LOADED,
    payload
  }
  }
